import { render, staticRenderFns } from "./SendClock.vue?vue&type=template&id=9284e4ba"
import script from "./SendClock.vue?vue&type=script&lang=js"
export * from "./SendClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports